import { render } from "./code-editor.vue?vue&type=template&id=40d1e42b"
import script from "./code-editor.vue?vue&type=script&lang=js"
export * from "./code-editor.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__